export enum TypographyVariants {
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
  BODY1 = 'body1',
  BODY2 = 'body2',
  OVERLINE = 'overline',
}

export enum TypographyColors {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  INFO = 'info',
  SUCCESS = 'success',
  ERROR = 'error',
  TEXT_PRIMARY = 'textPrimary',
  TEXT_SECONDARY = 'textSecondary',
}

export enum TypographyFontWeight {
  LIGHT = 'light',
  REGULAR = 'regular',
  MEDIUM = 'medium',
  BOLD = 'bold',
}

export enum TypographyAlign {
  LEFT = 'left',
  CENTER = 'center',
}
